import { render, staticRenderFns } from "./EnterpriseBaseData.vue?vue&type=template&id=627aa279"
import script from "./EnterpriseBaseData.vue?vue&type=script&lang=js"
export * from "./EnterpriseBaseData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports